import { css } from 'styled-components';

import minusIcon from 'client-ribbons-design-system/components/foundations/Iconography/assets/icons-24-minus.svg';
import plusIcon from 'client-ribbons-design-system/components/foundations/Iconography/assets/icons-24-plus.svg';

export const cusorOverrideZoomInIcon = css`
  cursor: url('${plusIcon}') 12 12, auto;
`;

export const cusorOverrideZoomOutIcon = css`
  cursor: url('${minusIcon}') 12 12, auto;
`;
